export default __webpack_public_path__ + "static/media/illustration-elements_illustration03.d805849c.svg";